module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.isActive) ? _c('span', [_c('Button', {
    attrs: {
      "type": _vm.buttonType,
      "icon": _vm.buttonIcon,
      "shape": _vm.buttonShape,
      "size": _vm.buttonSize
    }
  }, [_vm._v(_vm._s(_vm.buttonValue))])], 1) : _vm._e(), _vm._v(" "), (!_vm.isActive) ? _c('span', [_c('Button', {
    attrs: {
      "type": _vm.buttonType,
      "icon": _vm.buttonIcon,
      "shape": _vm.buttonShape,
      "size": _vm.buttonSize,
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.buttonValue))])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d69acbf","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/RuleButton.vue
// module id = 1687
// module chunks = 8